import { render, staticRenderFns } from "./app-markdown.vue?vue&type=template&id=0411a46a&"
import script from "./app-markdown.vue?vue&type=script&lang=js&"
export * from "./app-markdown.vue?vue&type=script&lang=js&"
import style0 from "./app-markdown.vue?vue&type=style&index=0&id=0411a46a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports